var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.36 6H7v6h7.24l.4 2H18V8h-5.24l-.4-2Z",
    fill: "#FC0D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6Zm3.6 8h-3.36l-.4-2H7V6h5.36l.4 2H18v6Z",
    fill: "#FC0D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlagIcon);
export default __webpack_public_path__ + "static/media/redFlagIcon.d43085b5cc3136453a06ee570052fae0.svg";
export { ForwardRef as ReactComponent };